<template>
  <v-card height="100%" v-once>
    <v-card-title primary-title>
      <div class="headline">{{labels.claimants}}</div>
    </v-card-title>
    <v-expansion-panel v-if="claimants.length > 0" class="elevation-0" expand :value="[true]">
      <v-expansion-panel-content v-for="(claimant,i) in claimants" :key="i">
        <div slot="header">
          <div class="body-2">
            Claimant No. {{claimant.clmtNo}} - {{claimant.clmtName}}
          </div>
        </div>
        <v-card>
          <v-card-text>
            <v-container fluid infoPadding>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-subheader class="queryLabel">{{labels.clmtStatus}}</v-subheader>
                  <div>{{claimantStatus(claimant.clmtStatus)}}</div>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="claimant.clmtStatus === 'E'">
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.clmtCoyName}}</v-subheader>
                  <div>{{claimant.clmtName}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.clmtRocUen}}</v-subheader>
                  <div>{{claimant.clmtRocUen}}</div>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-else>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.clmtSalutation}}</v-subheader>
                  <div>{{claimant.clmtSalutation}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.clmtName}}</v-subheader>
                  <div>{{claimant.clmtName}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.clmtNricPassport}}</v-subheader>
                  <div>{{claimant.clmtNricPassport}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.clmtDob}}</v-subheader>
                  <div>{{formatDisplayDate(claimant.clmtDob)}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.clmtMailAdd}}</v-subheader>
                  <div v-if="claimant.clmtPostalCode">
                    {{claimant.clmtAdd1}} {{claimant.clmtAdd2}} <span v-if="claimant.clmtAdd3">#{{claimant.clmtAdd3}}</span> {{claimant.clmtAdd4}}, Singapore {{claimant.clmtPostalCode}}
                  </div>
                  <div v-else>-</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.clmtEmail}}</v-subheader>
                  <div v-if="claimant.clmtEmail">{{claimant.clmtEmail}}</div>
                  <div v-else>-</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.clmtMobileNo}}</v-subheader>
                  <div v-if="claimant.clmtMobileNo">{{claimant.clmtMobileNo}}</div>
                  <div v-else>-</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.clmtTelNo1}}</v-subheader>
                  <div v-if="claimant.clmtTelNo1">{{claimant.clmtTelNo1}}</div>
                  <div v-else>-</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.clmtTelNo2}}</v-subheader>
                  <div v-if="claimant.clmtTelNo2">{{claimant.clmtTelNo2}}</div>
                  <div v-else>-</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.clmtFaxNo}}</v-subheader>
                  <div v-if="claimant.clmtFaxNo">{{claimant.clmtFaxNo}}</div>
                  <div v-else>-</div>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container fluid infoPadding>
              <v-expansion-panel v-if="claimant.clmItems.length > 0" class="mt-2" expand>
                <v-expansion-panel-content v-for="clmtItem in claimant.clmItems" :key="clmtItem.clmItemNo">
                  <div slot="header">
                    <div class="body-2">
                      Claim Item No. {{clmtItem.clmItemNo}} - {{clmtItem.lossDesc1}}
                    </div>
                  </div>
                  <v-card>
                    <v-card-text>
                      <v-container fluid infoPadding>
                        <v-layout row wrap>
                          <v-flex xs6>
                            <v-subheader class="queryLabel">{{labels.nol1}}</v-subheader>
                            <div>{{getNol1(clmtItem)}}</div>
                          </v-flex>
                          <v-flex xs6>
                            <v-subheader class="queryLabel">{{labels.nol2}}</v-subheader>
                            <div>{{getNol2(clmtItem)}}</div>
                          </v-flex>
                          <v-flex xs12>
                            <v-subheader class="queryLabel">{{labels.lossDesc1}}</v-subheader>
                            <div>{{clmtItem.lossDesc1}}</div>
                            <div>{{clmtItem.lossDesc2}}</div>
                            <div>{{clmtItem.lossDesc3}}</div>
                          </v-flex>
                          <v-flex xs12>
                            <v-divider></v-divider>
                          </v-flex>
                          <v-flex xs12>
                            <v-card-title>
                              <div class="body-2">{{labels.clmReserves}}</div>
                            </v-card-title>
                            <v-container fluid grid-list-sm v-if="clmtItem.clmReserves.length > 0">
                              <template v-for="reserve in clmtItem.clmReserves">
                                <v-layout :key="reserve.key" v-if="reserve.value !== 0" class="reservePadding">
                                  <v-flex xs2>
                                    <v-subheader class="queryLabel">{{reserve.key}}</v-subheader>
                                  </v-flex>
                                  <v-flex xs4>
                                    <v-subheader class="queryLabel">{{getClmReserveDesc(reserve)}}</v-subheader>
                                  </v-flex>
                                  <v-flex xs6>
                                    {{currPrefix}}{{formatDisplayNumber(reserve.value)}}
                                  </v-flex>
                                </v-layout>
                              </template>
                            </v-container>
                            <v-card-text v-else>
                              No Claim Reserves Available
                            </v-card-text>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-card-text v-else>
                No Claim Items Available
              </v-card-text>
            </v-container>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-card-text v-else>
      No Claimant Details Available
    </v-card-text>
  </v-card>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
import { claimantStatus } from '@/const/claims'
import { extractLabel } from '@/utils/extract'

export default {
  data() {
    return {
      labels: {
        claimants: 'Claimants Information',
        clmtStatus: 'Claimant Status',
        clmtSalutation: 'Salutation',
        clmtName: 'Name as in NRIC/Passport',
        clmtNricPassport: 'NRIC/Passport',
        clmtDob: 'Date of Birth',
        clmtCoyName: 'Name of Company',
        clmtRocUen: 'ROC/UEN',
        clmtMailAdd: 'Mailing Address',
        clmtEmail: 'Email',
        clmtMobileNo: 'Mobile No.',
        clmtTelNo1: 'Home No.',
        clmtTelNo2: 'Office No.',
        clmtFaxNo: 'Fax No.',
        nol1: 'Nature of Loss 1',
        nol2: 'Nature of Loss 2',
        lossDesc1: 'Loss Description',
        clmReserves: 'Claim Reserves'
      }
    }
  },
  computed: {
    claimForm() {
      return this.$store.state.claims.claimDetail.claimForm
    },
    claimants() {
      return this.claimForm.claimants
    },
    claimParam() {
      return this.$store.state.claims.claimDetail.claimParam
    },
    currPrefix() {
      return 'S$'
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(Number(xNum))
    },
    claimantStatus(clmtStatus) {
      if (clmtStatus) {
        return claimantStatus[clmtStatus]
      } else {
        return ' - '
      }
    },
    getNol1(clmtItem) {
      if (this.claimParam.nol1.data && this.claimParam.nol1.data.length > 0) {
        return extractLabel(this.claimParam.nol1.data, clmtItem.nol1)
      } else {
        return clmtItem.nol1 + ' - ' + clmtItem.nol1Desc
      }
    },
    getNol2(clmtItem) {
      if (this.claimParam.nol2 && this.claimParam.nol2.length > 0) {
        return extractLabel(this.claimParam.nol2, clmtItem.nol2)
      } else {
        return clmtItem.nol2 + ' - ' + clmtItem.nol2Desc
      }
    },
    getClmReserveDesc(clmReserve) {
      if (this.claimParam.reserve && this.claimParam.reserve.length > 0) {
        return extractLabel(this.claimParam.reserve, clmReserve.key)
      } else {
        return clmReserve.clmResCatDesc
      }
    }
  }
}
</script>

<style>
.infoPadding {
  padding: 10px;
}
.reservePadding {
  padding-left: 18px;
}
</style>
